let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4SJX4")).then(() => parcelRequire('i784l'));